module.exports = __webpack_public_path__ + "img/fractions.2e5be927.jpg";